import { useEffect, useState } from 'react'
import { useInstantSearch } from 'react-instantsearch'

import { useProductSearchContext } from '../context/productSearchContextValue'

type ResolvedClearRequest = {
  id: number
  resultQueryId?: string
}

export const useProductSearchClearAllStatus = (): {
  announceFiltersCleared: boolean
  isAnnouncementBusy: boolean
} => {
  const { clearAllRequestId } = useProductSearchContext()
  const { results, status } = useInstantSearch()
  const [previousQueryId, setPreviousQueryId] = useState(results.queryID)
  const [resolvedClearRequest, setResolvedClearRequest] =
    useState<ResolvedClearRequest>({ id: 0 })

  const isClearAllPending = clearAllRequestId > resolvedClearRequest.id
  const hasNewResults = status === 'idle' && results.queryID !== previousQueryId
  const announceFiltersCleared = isClearAllPending
    ? hasNewResults
    : resolvedClearRequest.resultQueryId === results.queryID

  useEffect(() => {
    if (!isClearAllPending) {
      if (status === 'idle' && previousQueryId !== results.queryID) {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- remember the settled result for the next clear request
        setPreviousQueryId(results.queryID)
      }

      return
    }

    if (!hasNewResults && status !== 'error') {
      return
    }

    setResolvedClearRequest({
      id: clearAllRequestId,
      resultQueryId: hasNewResults ? results.queryID : undefined,
    })
  }, [
    clearAllRequestId,
    hasNewResults,
    isClearAllPending,
    previousQueryId,
    results.queryID,
    status,
  ])

  return {
    announceFiltersCleared,
    isAnnouncementBusy:
      isClearAllPending || status === 'loading' || status === 'stalled',
  }
}
